import { EntityState } from '@ngrx/entity';
import { Payment } from '../../models/payment';
import { FilterState } from 'src/app/modules/shared/models/filter-state';
import { PaymentIntent } from '../../models/paymentIntent';

export const paymentFeatureKey = 'payments';

export interface PaymentState extends EntityState<Payment> {
    error: any;
    totalCount: number;
    filter: FilterState;
    paymentIntent: PaymentIntent;
    giftCard: boolean
}
